let baseConfig = { clientId: '', environment: 'sandbox', region: 'default' };
let config;
let sardineContext;
let deviceData;
const setBaseConfig = (params) => {
    if (params) {
        baseConfig = { ...params };
    }
};
const getBaseConfig = () => baseConfig;
const setConfig = (params) => {
    if (params) {
        config = { ...params };
    }
};
const getConfig = () => config;
const setContext = (context) => {
    if (context) {
        sardineContext = context;
    }
};
const getDeviceData = () => deviceData;
const setDeviceData = (data) => {
    if (data) {
        deviceData = data;
    }
};
const getContext = () => sardineContext;
const getSardineHost = () => {
    const { environment, region } = getBaseConfig();
    const isSandbox = environment === 'sandbox';
    var regionValue = region === 'default' ? '' : region || '';
    regionValue = regionValue ? `${regionValue}.` : '';
    return isSandbox ? `api.sandbox.${regionValue}sardine.ai` : `api.${regionValue}sardine.ai`;
};
export { setBaseConfig, getBaseConfig, setConfig, getConfig, setContext, getContext, getDeviceData, setDeviceData, getSardineHost, };
